/**
 * SVG 图标组件
 * 使用 symbol 定义，便于复用
 */

import React from 'react'

// 图标定义组件（隐藏，仅用于定义 SVG symbols）
export const IconDefs: React.FC = () => (
  <svg style={{ display: 'none' }}>
    {/* 首页 */}
    <symbol id="icon-home" viewBox="0 0 24 24">
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </symbol>
    {/* 发现 */}
    <symbol id="icon-explore" viewBox="0 0 24 24">
      <path d="M12 10.9c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l7.1-7.1c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-7.1 7.1zm-8.2 8.2c-1.2-1.2-1.2-3.1 0-4.2l5.7-5.7c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-5.7 5.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l5.7-5.7c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-5.7 5.7c-1.2 1.2-3.1 1.2-4.2 0l-1.4-1.4z" />
    </symbol>
    {/* 通知 */}
    <symbol id="icon-notify" viewBox="0 0 24 24">
      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.1-1.6-5.6-4.5-6.3V4c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v.7C7.6 5.4 6 7.9 6 11v5l-2 2v1h16v-1l-2-2z" />
    </symbol>
    {/* 我的 */}
    <symbol id="icon-user" viewBox="0 0 24 24">
      <path d="M12 12c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z" />
    </symbol>
    {/* 发布 */}
    <symbol id="icon-add" viewBox="0 0 24 24">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </symbol>
    {/* 搜索 */}
    <symbol id="icon-search" viewBox="0 0 24 24">
      <path d="M15.5 14h-.8l-.3-.3c1-1.1 1.6-2.6 1.6-4.2 0-3.9-3.1-7-7-7S2 5.6 2 9.5 5.1 16.5 9 16.5c1.6 0 3.1-.6 4.2-1.6l.3.3v.8l5 5 1.5-1.5-5-5zm-6.5 0c-2.5 0-4.5-2-4.5-4.5S6.5 5 9 5s4.5 2 4.5 4.5S11.5 14 9 14z" />
    </symbol>
    {/* 点赞 */}
    <symbol id="icon-heart" viewBox="0 0 24 24">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
    </symbol>
    {/* 实验室 */}
    <symbol id="icon-lab" viewBox="0 0 24 24">
      <path d="M21.16 16.84L14 7.64V4h1V2H9v2h1v3.64L2.84 16.84c-.45.58-.2 1.44.53 1.61L12 21.5l8.63-3.05c.73-.17.98-1.03.53-1.61zM12 19l-6.36-2.25L11 9.88V4h2v5.88l5.36 6.87L12 19z" />
    </symbol>
    {/* 看板 */}
    <symbol id="icon-dashboard" viewBox="0 0 24 24">
      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z" />
    </symbol>
    {/* 设置 */}
    <symbol id="icon-settings" viewBox="0 0 24 24">
      <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.06-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.73,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.06,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 C9.64,21.83,9.83,22,10.08,22h3.84c0.24,0,0.43-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.49-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
    </symbol>
    {/* 暂停 */}
    <symbol id="icon-pause" viewBox="0 0 24 24">
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
    </symbol>
    {/* 播放 */}
    <symbol id="icon-play" viewBox="0 0 24 24">
      <path d="M8 5v14l11-7z"/>
    </symbol>
    {/* 返回 */}
    <symbol id="icon-arrow-left" viewBox="0 0 24 24">
      <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
    </symbol>
  </svg>
)

// 图标使用组件
interface IconProps {
  name: string
  className?: string
  size?: number
}

export const Icon: React.FC<IconProps> = ({ name, className = '', size = 24 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    fill="currentColor"
  >
    <use href={`#icon-${name}`} />
  </svg>
)

// 预定义图标组件
export const HomeIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="home" className={className} />
)

export const ExploreIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="explore" className={className} />
)

export const NotifyIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="notify" className={className} />
)

export const UserIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="user" className={className} />
)

export const AddIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="add" className={className} />
)

export const SearchIcon: React.FC<{ className?: string; size?: number }> = ({ className, size }) => (
  <Icon name="search" className={className} size={size} />
)

export const HeartIcon: React.FC<{ className?: string; size?: number }> = ({ className, size }) => (
  <Icon name="heart" className={className} size={size} />
)

export const LabIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="lab" className={className} />
)

export const DashboardIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="dashboard" className={className} />
)

export const SettingsIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="settings" className={className} />
)

export const PauseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="pause" className={className} />
)

export const PlayIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon name="play" className={className} />
)

export const ArrowLeftIcon: React.FC<{ className?: string; size?: number }> = ({ className, size }) => (
  <Icon name="arrow-left" className={className} size={size} />
)